import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React from 'react';
import clone from 'clone';
import { getParent, isAlive, types } from 'mobx-state-tree';
// jbrowse
import { getConf } from '@jbrowse/core/configuration';
import { BaseDisplay } from '@jbrowse/core/pluggableElementTypes/models';
import CircularChordRendererType from '@jbrowse/core/pluggableElementTypes/renderers/CircularChordRendererType';
import { getContainingView, getSession, getEnv, isFeature, makeAbortableReaction, ReactRendering } from '@jbrowse/core/util';
import { getParentRenderProps, getRpcSessionId, getTrackAssemblyNames } from '@jbrowse/core/util/tracks';
// locals
import { renderReactionData, renderReactionEffect } from './renderReaction';
/**
 * #stateModel BaseChordDisplay
 * extends `BaseDisplay`
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars
export var BaseChordDisplayModel = types.compose('BaseChordDisplay', BaseDisplay, types.model({
  /**
   * #property
   */
  bezierRadiusRatio: 0.1,
  /**
   * #property
   */
  assemblyName: types.maybe(types.string)
})).volatile(function () {
  return {
    // NOTE: all this volatile stuff has to be filled in at once
    // so that it stays consistent
    filled: false,
    reactElement: undefined,
    data: undefined,
    html: undefined,
    message: '',
    renderingComponent: undefined,
    refNameMap: undefined
  };
}).actions(function (self) {
  var _getEnv = getEnv(self),
    pluginManager = _getEnv.pluginManager;
  var track = self;
  return {
    /**
     * #action
     */
    onChordClick: function onChordClick(feature) {
      getConf(self, 'onChordClick', {
        feature: feature,
        track: track,
        pluginManager: pluginManager
      });
    }
  };
}).views(function (self) {
  return {
    /**
     * #getter
     */
    get blockDefinitions() {
      var view = getContainingView(self);
      var origSlices = view.staticSlices;
      if (!self.refNameMap) {
        return origSlices;
      }
      var slices = clone(origSlices);
      slices.forEach(function (slice) {
        var regions = slice.region.elided ? slice.region.regions : [slice.region];
        regions.forEach(function (region) {
          var _a;
          var renamed = (_a = self.refNameMap) === null || _a === void 0 ? void 0 : _a[region.refName];
          if (renamed && region.refName !== renamed) {
            region.refName = renamed;
          }
        });
      });
      return slices;
    },
    /**
     * #method
     */
    renderProps: function renderProps() {
      var view = getContainingView(self);
      return _objectSpread({}, getParentRenderProps(self), {
        rpcDriverName: self.rpcDriverName,
        displayModel: self,
        bezierRadius: view.radiusPx * self.bezierRadiusRatio,
        radius: view.radiusPx,
        blockDefinitions: this.blockDefinitions,
        onChordClick: self.onChordClick
      });
    },
    /**
     * #getter
     * the pluggable element type object for this display's
     * renderer
     */
    get rendererType() {
      var display = self;
      var _getEnv2 = getEnv(self),
        pluginManager = _getEnv2.pluginManager;
      var ThisRendererType = pluginManager.getRendererType(self.rendererTypeName);
      if (!ThisRendererType) {
        throw new Error("renderer \"".concat(display.rendererTypeName, "\" not found"));
      }
      if (!ThisRendererType.ReactComponent) {
        throw new Error("renderer ".concat(display.rendererTypeName, " has no ReactComponent, it may not be completely implemented yet"));
      }
      return ThisRendererType;
    },
    /**
     * #method
     */
    isCompatibleWithRenderer: function isCompatibleWithRenderer(renderer) {
      return !!(renderer instanceof CircularChordRendererType);
    },
    /**
     * #getter
     * returns a string feature ID if the globally-selected object
     * is probably a feature
     */
    get selectedFeatureId() {
      if (!isAlive(self)) {
        return undefined;
      }
      var session = getSession(self);
      if (!session) {
        return undefined;
      }
      var selection = session.selection; // does it quack like a feature?
      if (isFeature(selection)) {
        return selection.id();
      }
      return undefined;
    }
  };
}).actions(function (self) {
  return {
    /**
     * #action
     */
    renderStarted: function renderStarted() {
      self.filled = false;
      self.message = '';
      self.reactElement = undefined;
      self.data = undefined;
      self.html = undefined;
      self.error = undefined;
      self.renderingComponent = undefined;
    },
    /**
     * #action
     */
    renderSuccess: function renderSuccess(_ref) {
      var message = _ref.message,
        data = _ref.data,
        reactElement = _ref.reactElement,
        html = _ref.html,
        renderingComponent = _ref.renderingComponent;
      if (message) {
        self.filled = false;
        self.message = message;
        self.reactElement = undefined;
        self.data = undefined;
        self.html = undefined;
        self.error = undefined;
        self.renderingComponent = undefined;
      } else {
        self.filled = true;
        self.message = '';
        self.reactElement = reactElement;
        self.data = data;
        self.html = html;
        self.error = undefined;
        self.renderingComponent = renderingComponent;
      }
    },
    /**
     * #action
     */
    renderError: function renderError(error) {
      console.error(error);
      // the rendering failed for some reason
      self.filled = false;
      self.message = '';
      self.reactElement = undefined;
      self.html = undefined;
      self.data = undefined;
      self.error = error;
      self.renderingComponent = undefined;
    },
    /**
     * #action
     */
    setRefNameMap: function setRefNameMap(refNameMap) {
      self.refNameMap = refNameMap;
    }
  };
}).actions(function (self) {
  return {
    afterAttach: function afterAttach() {
      makeAbortableReaction(self, renderReactionData,
      // @ts-ignore
      renderReactionEffect, {
        name: "".concat(self.type, " ").concat(self.id, " rendering"),
        // delay: self.renderDelay || 300,
        fireImmediately: true
      }, self.renderStarted, self.renderSuccess, self.renderError);
      makeAbortableReaction(self, function () {
        return {
          assemblyNames: getTrackAssemblyNames(self.parentTrack),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          adapter: getConf(getParent(self, 2), 'adapter'),
          assemblyManager: getSession(self).assemblyManager
        };
      },
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2, signal) {
          var assemblyNames, adapter, assemblyManager;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                assemblyNames = _ref2.assemblyNames, adapter = _ref2.adapter, assemblyManager = _ref2.assemblyManager;
                return _context.abrupt("return", assemblyManager.getRefNameMapForAdapter(adapter, assemblyNames[0], {
                  signal: signal,
                  sessionId: getRpcSessionId(self)
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }(), {
        name: "".concat(self.type, " ").concat(self.id, " getting refNames"),
        fireImmediately: true
      }, function () {}, function (refNameMap) {
        return self.setRefNameMap(refNameMap);
      }, function (error) {
        console.error(error);
        self.setError(error);
      });
    }
  };
}).views(function (self) {
  return {
    /**
     * #method
     */
    renderSvg: function () {
      var _renderSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(opts) {
        var data, rendering;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = renderReactionData(self);
              _context2.next = 3;
              return renderReactionEffect(_objectSpread({}, data, {
                exportSVG: opts,
                theme: opts.theme || data.renderProps.theme
              }), undefined, self);
            case 3:
              rendering = _context2.sent;
              return _context2.abrupt("return", React.createElement(ReactRendering, {
                rendering: rendering
              }));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function renderSvg(_x3) {
        return _renderSvg.apply(this, arguments);
      }
      return renderSvg;
    }()
  };
});